import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoices-payments',
  templateUrl: './invoices-payments.component.html',
  styleUrls: ['./invoices-payments.component.scss']
})
export class InvoicesPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
